import { useSelector } from 'react-redux';
import LoadingLottie from '../components/atoms/LoadingLottie';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import AdminSectionTitle from '../components/AdminSectionTitle';
import EventMenuOption from '../components/EventMenuOption';
import useNavigateWithQuery from '../hooks/useNavigateWithQuery';
import copyLinkToClipboard from '../utils/copyLinkToClipboard';
import config from '../config/config';
import QrCode02Icon from '../components/icons/QrCode02Icon';
import { RootState, useCreateScannerKeyMutation } from '../store';
import { IconMove1 } from '../components/icons';

const AdminScanningPage: React.FC = () => {
  const { event, eventLoading } = useGetSelectedEvent();
  const navigate = useNavigateWithQuery();
  const userData = useSelector((state: RootState) => state.auth.user);
  const [createScannerKey] = useCreateScannerKeyMutation();

  if (eventLoading) {
    return <LoadingLottie />;
  }

  if (!event) {
    return <div>No se encontró el evento</div>;
  }

  const handleScannerClick = () => {
    navigate('../scanner');
  };

  const handleGenerateScannerKey = async () => {
    if (!userData?.id) {
      return;
    }
    try {
      const result = await createScannerKey({ businessId: event.business_id }).unwrap();
      if (result?.data?.key) {
        const loginUrl = `${config.baseDomain}/login?scannerKey=${result.data.key}`;
        copyLinkToClipboard(loginUrl);
      }
    } catch (error) {
      console.error('Error generating scanner key:', error);
    }
  };

  return (
    <div className="flex flex-col gap-8 my-6 w-full">
      <AdminSectionTitle
        title={'Eventos'}
        subtitle={`${event?.name} - Escanear códigos`}
      />

      <div className='glass-surface'>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <EventMenuOption
            id={event.id}
            title="Abrir lector de entradas"
            info="En esta sección podrás escanear los códigos QR de los asistentes para registrar su entrada al evento."
            buttonLabel="Abrir escáner"
            onClick={handleScannerClick}
            icon={<QrCode02Icon className='w-10 h-10 ml-2 mt-1 text-primary-500' />}
          />
          <EventMenuOption
            id={event.id}
            title="Generar link de escaneo"
            info="Genera un link de acceso temporal para que otros usuarios puedan acceder al lector de entradas. Este link es válido por 1 hora y cada vez que se genera uno el anterior se invalida."
            buttonLabel="Copiar link"
            onClick={handleGenerateScannerKey}
            icon={<IconMove1 className='w-10 h-10 ml-2 mt-1' />}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminScanningPage;
